// TODO: Query that waits for a resolution to render
// TODO: Paginated data component
// TODO: Vue to Firestore protected sync
import { VueFirestoreComposerModule } from "./vue-firestore-composer";
export * from "./vue-firestore-refs";
export * from "./vue-firestore-composer";
export const vueFirestoreComposer = VueFirestoreComposerModule.vueFirestoreComposer;
//# sourceMappingURL=vue-firestore.js.map